"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = exports.Item = void 0;
var react_1 = __importStar(require("react"));
var Input_1 = require("../Input/Input");
var DropdownOption_1 = require("./DropdownOption");
var Item = /** @class */ (function () {
    function Item() {
        this.name = '';
        this.value = '';
    }
    return Item;
}());
exports.Item = Item;
var Dropdown = function (_a) {
    var warning = _a.warning, title = _a.title, _b = _a.defaultValue, defaultValue = _b === void 0 ? '' : _b, _c = _a.items, items = _c === void 0 ? [] : _c, _d = _a.autoComplete, autoComplete = _d === void 0 ? false : _d, _e = _a.autoFocus, autoFocus = _e === void 0 ? false : _e, value = _a.value, setValue = _a.setValue, _f = _a.placeholder, placeholder = _f === void 0 ? '' : _f, errorEl = _a.errorEl, required = _a.required, onKeyDown = _a.onKeyDown, _g = _a.customClasses, customClasses = _g === void 0 ? '' : _g, reference = _a.reference, _h = _a.name, name = _h === void 0 ? '' : _h, typeAheadLen = _a.typeAheadLen;
    var _j = react_1.useState(false), open = _j[0], setOpen = _j[1];
    var node = react_1.useRef(null);
    var _k = react_1.useState(items), shownItems = _k[0], setShownItems = _k[1];
    react_1.useEffect(function () {
        if (!autoComplete && (items === null || items === void 0 ? void 0 : items.length) && !value) {
            setValue(items[0]);
        }
    }, []);
    react_1.useEffect(function () {
        var _a, _b, _c, _d;
        var len = typeAheadLen || 3;
        if (autoComplete) {
            setShownItems([]);
            if (items.length && (value === null || value === void 0 ? void 0 : value.name) && ((_a = value === null || value === void 0 ? void 0 : value.name) === null || _a === void 0 ? void 0 : _a.length) >= len) {
                var tempItems = [];
                for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                    var item = items_1[_i];
                    if (((_b = item === null || item === void 0 ? void 0 : item.name) === null || _b === void 0 ? void 0 : _b.substr(0, (_c = value === null || value === void 0 ? void 0 : value.name) === null || _c === void 0 ? void 0 : _c.length).toUpperCase()) === ((_d = value === null || value === void 0 ? void 0 : value.name) === null || _d === void 0 ? void 0 : _d.toUpperCase())) {
                        tempItems.push(item);
                        if ((item === null || item === void 0 ? void 0 : item.name) === (value === null || value === void 0 ? void 0 : value.name)) {
                            setValue(item);
                        }
                    }
                }
                setShownItems(tempItems);
            }
        }
    }, [value === null || value === void 0 ? void 0 : value.name]);
    var close = react_1.useCallback(function (e) {
        var _a;
        if (!((_a = node.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            setOpen(false);
        }
    }, []);
    var onSelectItem = function (item) {
        setValue(item);
        setOpen(false);
    };
    react_1.useEffect(function () {
        document.addEventListener('mousedown', close);
        return function () {
            document.removeEventListener('mousedown', close);
        };
    }, []);
    return (react_1.default.createElement("div", { className: "axxes-custom-dropdown " + (autoComplete && '-autocomplete') + " " + (customClasses && customClasses), ref: node },
        react_1.default.createElement(Input_1.Input, { title: title, warning: warning, name: name, reference: reference, autoFocus: autoFocus, readOnly: !autoComplete, value: (value === null || value === void 0 ? void 0 : value.name) || '', onChange: function (e) { return setValue({ value: '', name: e.target.value }); }, onClick: function () {
                if (!autoComplete || (value === null || value === void 0 ? void 0 : value.name.length) >= 3)
                    setOpen(!open);
            }, placeholder: placeholder, required: required, onKeyDown: function (e) {
                setOpen(true);
                if (onKeyDown) {
                    onKeyDown(e);
                }
            } }),
        !autoComplete && (react_1.default.createElement("div", { className: "axxes-custom-dropdown__toggle " + (open && '-open') },
            react_1.default.createElement("div", { className: 'axxes-icons axxes-icon-down-open-big' }))),
        react_1.default.createElement("div", { className: 'axxes-custom-dropdown__wrapper' },
            react_1.default.createElement("ul", { className: "axxes-custom-dropdown__list " + (open && '-open') }, shownItems === null || shownItems === void 0 ? void 0 : shownItems.map(function (item, index) { return (react_1.default.createElement(DropdownOption_1.DropdownOption, { key: index, onClick: function () { return onSelectItem(item); }, value: item === null || item === void 0 ? void 0 : item.value }, item === null || item === void 0 ? void 0 : item.name)); })))));
};
exports.Dropdown = Dropdown;
